import { STDirectionPml } from '@tencent/slide-sdk-model';
import { EPpGuideOrientation } from '@src/slide/domain/ui-model/element-modeles/Interface/guide-model-v3.interface';

// 参考线方向 - sdk对上层类型映射
export const ORIENT_MAP = new Map([
    [STDirectionPml?.horz, EPpGuideOrientation.ppHorizontalGuide],
    [STDirectionPml?.vert, EPpGuideOrientation.ppVerticalGuide],
]);
